export default class Accordion {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.accordion:not(.accordion--editable)'), el => {
			new Accordion(el);
		});
	}

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.activeClass = 'accordion__item--active';
		this.activeSelector = '.' + this.activeClass;
		this.currentItem = element.querySelector(this.activeSelector);
        this.isSimple = this.element.classList.contains('accordion--is-simple');

        let accordionButton = Array.from(this.element.querySelectorAll('.accordion__item-heading'));
		let accordionContentText = Array.from(this.element.querySelectorAll('.accordion__item-text'));

		if (window.innerWidth > 991) {
			accordionContentText.forEach(el => {
				if (this.isOverflowingItemContent(el)) {
					this.setOverflowingItemContent(el);
				}
			});
		}

        Array.prototype.forEach.call(accordionButton, el => {
            let accordionListItem = el.parentNode;
            el.addEventListener('click', () => {
                const open = new CustomEvent('openAccordionItem', {detail: {item: accordionListItem}})
                window.dispatchEvent(open);
            });
        });

        window.addEventListener('openAccordionItem', (e) => {
            let accordionActiveItem = e.detail.item;

            if (this.isSimple && this.isActiveItem(accordionActiveItem)) {
                // toggle close item
                this.setInactiveItem(accordionActiveItem);
                const closedEvent = new CustomEvent('closedAccordionItem', {detail: {item: accordionActiveItem}})
                window.dispatchEvent(closedEvent);
            } else {
                this.setActiveItem(accordionActiveItem);
            }

            // scroll to item on mobile
            if (window.innerWidth < 992) {
                let timeout = 350;
                let mobileOffset = 0;
                let currentButton = accordionActiveItem.querySelector(`.accordion__item-heading`);
                let currentList = this.currentItem.parentElement;

                setTimeout(() => {
                    mobileOffset = currentList.offsetTop + currentButton.offsetTop - 15

                    window.scrollTo({
                        top: mobileOffset - document.querySelector('.header__inner').getBoundingClientRect().height,
                        behavior: "smooth"
                    });

                    this.currentItem.querySelector('.accordion__item-content').scrollTo({top: 0});
                }, timeout)
            }
		})
	}

	isActiveItem(el) {
		return el.classList.contains(this.activeClass);
	}

	getActiveItem() {
		return this.element.querySelector(this.activeSelector);
	}

	setActiveItem(el) {
		if (!this.isActiveItem(el)) {
			this.setInactiveItem(this.getActiveItem());
			el.classList.add(this.activeClass);
			this.currentItem = el;
		}
	}

    toggleActiveItem(el) {
        this[!this.isActiveItem(el) ? 'setActiveItem' : 'setInactiveItem'](el);
	}

	setInactiveItem(el) {
		if (!el) return;
        el.classList.remove(this.activeClass);
	}

	isOverflowingItemContent(el) {
		return el.getBoundingClientRect().bottom > el.parentNode.getBoundingClientRect().bottom;
	}

	setOverflowingItemContent(el) {
		let accordionItem = el.parentNode;
		let scrolled = (element) => {
			if (element.offsetHeight + element.scrollTop + 20 >= element.scrollHeight) {
				element.parentNode.classList.remove('is-overlap');
			} else {
				element.parentNode.classList.add('is-overlap');
			}
		}
		//create and append arrow
		(() => {
			let accordionItem = el.parentNode;
			accordionItem.parentNode.classList.add('is-overlap');
			let span = document.createElement("SPAN");
			span.classList.add('arrow');
			accordionItem.parentNode.append(span);

			span.addEventListener('click', () => {
				accordionItem.scrollTo({
					top: accordionItem.scrollTop + accordionItem.getBoundingClientRect().height - 60,
					behavior: "smooth"
				});
			});
		})()

		accordionItem.addEventListener('scroll', e => {
			scrolled(accordionItem, e);
		});
	}

    setContentHeight(el) {
        let picture = el.querySelector('picture');

        if (picture) {
            picture.addEventListener('lazyloaded', () => {
                el.style.setProperty('--height', Math.ceil(el.querySelector('.accordion__item-content__inner').getBoundingClientRect().height));
            });
        } else {
            setTimeout(()=> {
                el.style.setProperty('--height', Math.ceil(el.querySelector('.accordion__item-content__inner').getBoundingClientRect().height));
            }, 150);
        }
    }
}
